/* Jubi Technique Match — 3 taps to a technique recommendation.
   Order: how the room lives (constraints first) → what you want underfoot
   (novice-physical language, sets the candidate) → how long it should live.
   Studio facts (Cassie, Jul 2026): all techniques are durable; loomed,
   knotted, and woven are SIGNIFICANTLY more durable long-term. Tufted is the
   prominent offering — never frame it negatively; steer via the other
   techniques' strengths instead. Height is a real reason people choose
   flatweave; shag is its own outcome.
   Reuses the Size Helper's markup pattern and stylesheet (jsh__ classes). */
(function () {
  'use strict';

  var TECHNIQUES = {
    tufted: {
      name: 'Hand-Tufted',
      handle: 'tufted-rugs',
      why: 'hand-tufting is sculpted by hand through a canvas backing — carved detail, bold dimension, and the technique behind most of the Jubi collection, and the fastest to make (made in 3–4 weeks)'
    },
    knotted: {
      name: 'Hand-Knotted',
      handle: 'hand-knotted-rugs',
      why: 'hand-knotting ties every knot row by row — the densest, finest construction we make, built to be passed down'
    },
    woven: {
      name: 'Handwoven',
      handle: 'woven-rugs',
      why: 'handweaving makes a flat, fabric-like profile — it clears doors, layers beautifully, and takes hard daily life in stride'
    },
    loomed: {
      name: 'Hand-Loomed',
      handle: 'hand-loomed-rugs',
      why: 'hand-looming gives an even, velvety pile that is tougher than it feels — one quiet color, done perfectly, built for everyday life'
    },
    shag: {
      name: 'Shag',
      handle: 'shag-rugs',
      why: 'a deep, sink-in pile that turns a floor into furniture — softness as the whole point'
    }
  };

  function init(root) {
    if (root.dataset.jtmInit) return;
    root.dataset.jtmInit = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('.jsh__step'));
    var result = root.querySelector('.jsh__result');
    var resultName = root.querySelector('[data-jtm-name]');
    var resultWhy = root.querySelector('[data-jtm-why]');
    var shopLink = root.querySelector('[data-jtm-shop]');

    var state = { traffic: 'everyday', candidate: null, horizon: 'years' };

    function show(index) {
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      if (result) result.classList.remove('is-active');
      root.classList.remove('jsh--answered');
      var q = steps[index] && steps[index].querySelector('.jsh__question');
      if (q) q.focus();
    }

    /* Verdict = candidate, steered by the other techniques' strengths —
       never by naming a weakness of tufted (the prominent offering).
       Knotted has its own feel door (low & dense) AND earns the heirloom
       paths: pattern-plush + generations walks to knotted with praise.
       Solid-plush + generations stays loomed (very durable; a solid-color
       lover doesn't belong in the pattern-led knotted collection). */
    function decide() {
      var tech = state.candidate;
      var note = '';

      if (tech === 'tufted' && state.horizon === 'generations') {
        tech = 'knotted';
        note = ' You asked for a soft pile that lasts — and for a rug meant to be passed down, hand-knotting is the construction built for that horizon.';
      } else if (tech === 'tufted' && state.traffic === 'busy' && state.horizon === 'decades') {
        note = ' Planning on decades of heavy traffic? Hand-loomed pairs a similar softness with our longest-haul toughness — worth seeing side by side.';
      }

      if (tech === 'shag' && state.traffic === 'busy') {
        note = ' Deep pile is happiest in calmer rooms — bedrooms and dens are its natural habitat.';
      }

      return { tech: TECHNIQUES[tech], note: note };
    }

    function renderResult() {
      var verdict = decide();
      if (resultName) resultName.textContent = verdict.tech.name;
      if (resultWhy) resultWhy.textContent = 'Because ' + verdict.tech.why + '.' + verdict.note;
      if (shopLink) {
        shopLink.textContent = 'Shop ' + verdict.tech.name + ' Rugs';
        shopLink.href = '/collections/' + verdict.tech.handle;
      }
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      root.classList.add('jsh--answered');
      if (result) {
        result.classList.add('is-active');
        var heading = result.querySelector('.jsh__result-size');
        if (heading) heading.focus();
      }
    }

    root.querySelectorAll('[data-jtm-traffic]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-jtm-traffic]').forEach(function (c) { c.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.traffic = btn.getAttribute('data-jtm-traffic');
        show(1);
      });
    });

    root.querySelectorAll('[data-jtm-feel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-jtm-feel]').forEach(function (c) { c.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.candidate = btn.getAttribute('data-jtm-feel');
        show(2);
      });
    });

    root.querySelectorAll('[data-jtm-horizon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-jtm-horizon]').forEach(function (c) { c.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.horizon = btn.getAttribute('data-jtm-horizon');
        renderResult();
      });
    });

    root.querySelectorAll('[data-jtm-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(parseInt(btn.getAttribute('data-jtm-back'), 10) || 0);
      });
    });

    var restart = root.querySelector('[data-jtm-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { traffic: 'everyday', candidate: null, horizon: 'years' };
        root.querySelectorAll('.jsh__chip.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
        show(0);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-technique-match]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('[data-technique-match]');
    if (el) init(el);
  });
})();
